/*
 * RJ Charm Bar cart guard (Charm Bar CRO DEV, Oct 2026)
 * Keeps Charm Bar builds together in the cart drawer and cart page:
 *  - groups the lines of one build (chain first, then charms, then finishing)
 *  - hides per-line quantity/remove controls for build lines and offers one "Remove this build"
 *  - if a build's charm count changes by any route, swaps the hand-assembly tier so the price stays right
 * Lines are linked by the hidden line-item property _build_id written by rj-charm-builder.js.
 */
(function () {
  'use strict';
  if (window.__rjccLoaded) return;
  window.__rjccLoaded = true;

  var ROLE_ORDER = { chain: 0, charm: 1, finish: 2 };
  var busy = false, timer = null;

  function css() {
    if (document.getElementById('rjcc-style')) return;
    var st = document.createElement('style');
    st.id = 'rjcc-style';
    st.textContent =
      '.rjcc-locked quantity-selector,.rjcc-locked .cart-item-remove,.rjcc-locked .quantity{display:none!important}' +
      '.rjcc-line{border-left:3px solid #fec7ca}' +
      '.rjcc-head{display:flex;flex-wrap:wrap;align-items:center;justify-content:space-between;gap:6px 12px;margin:8px 0 4px;padding:10px 12px;border-radius:14px;background:#fff;border:1px solid rgba(103,21,32,.14);color:#671520;font-size:13px;line-height:1.35}' +
      '.rjcc-head strong{font-weight:600}' +
      '.rjcc-head button{background:none;border:0;padding:6px 0;min-height:36px;font:inherit;font-weight:600;color:#671520;text-decoration:underline;text-underline-offset:3px;cursor:pointer}' +
      '.rjcc-qty{font-size:13px;color:rgba(103,21,32,.68)}' +
      '.rjcc-warn{flex-basis:100%;color:#a91212;font-weight:600}';
    document.head.appendChild(st);
  }

  function money(cents, currency) {
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', { style: 'currency', currency: currency || 'GBP' }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2); }
  }

  function getCart() { return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }); }
  function post(url, body) {
    return fetch(url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { return { ok: r.ok, j: j }; }); });
  }
  var warnings = {};
  function warn(id, msg) { warnings[id] = msg; }
  function refreshUi() {
    if (document.getElementById('Cart-Drawer')) document.dispatchEvent(new CustomEvent('cart:refresh'));
    if (/\/cart\/?$/.test(location.pathname)) location.reload();
  }

  function groups(cart) {
    var g = {};
    cart.items.forEach(function (it, idx) {
      var p = it.properties || {};
      var id = p._build_id;
      if (!id || !/^[A-Z0-9]{4,8}$/.test(String(id))) return;
      (g[id] = g[id] || { id: id, items: [] }).items.push({ item: it, line: idx + 1, role: p._rj_role || 'charm' });
    });
    return g;
  }

  /* Hand assembly tier titles are charm-count ranges, e.g. "3-4". */
  function tierFits(title, n) {
    var m = String(title || '').match(/(\d+)\s*[-–]\s*(\d+)/);
    return !m || (n >= +m[1] && n <= +m[2]);
  }

  /* Repair a build whose charm count no longer matches its hand-assembly tier. */
  function repair(cart) {
    var g = groups(cart), jobs = [];
    Object.keys(g).forEach(function (id) {
      var grp = g[id];
      var n = grp.items.filter(function (x) { return x.role === 'charm'; }).reduce(function (a, x) { return a + x.item.quantity; }, 0);
      var fin = grp.items.filter(function (x) { return x.role === 'finish'; })[0];
      if (!fin || (fin.item.properties || {})._rj_finish !== 'hand' || !n) return;
      if (tierFits(fin.item.variant_title, n) && fin.item.quantity === 1) return;
      jobs.push({ fin: fin, n: n });
    });
    if (!jobs.length) return Promise.resolve(false);
    var job = jobs[0];
    return fetch('/products/' + job.fin.item.handle + '.js').then(function (r) { return r.json(); }).then(function (p) {
      var v = p.variants.filter(function (x) { return tierFits(x.title, job.n); })[0];
      if (!v) return false;
      var props = Object.assign({}, job.fin.item.properties, { For: job.n + ' charm' + (job.n > 1 ? 's' : '') });
      if (!v.available) { warn(job.fin.item.properties._build_id, 'The assembly option for ' + job.n + ' charms is unavailable. Please remove the build and add it again.'); return false; }
      return post('/cart/add.js', { items: [{ id: v.id, quantity: 1, properties: props }] }).then(function (res) {
        if (!res.ok) { warn(job.fin.item.properties._build_id, 'We couldn’t update the assembly price for this build. Please remove it and add it again.'); return false; }
        var upd = {}; upd[job.fin.item.key] = 0;
        return post('/cart/update.js', { updates: upd }).then(function () { return true; });
      });
    });
  }

  function lineEl(root, key) {
    var q = root.querySelector('quantity-selector[data-id="' + (window.CSS && CSS.escape ? CSS.escape(key) : key) + '"]');
    /* the whole row: on the cart page each .product-cart-item sits inside its own #CartItem-n wrapper */
    if (q) return q.closest('[id^="CartItem-"], [id^="CartDrawerItem-"]') || q.closest('.product-cart-item');
    var el = root.querySelector('[data-product-id="' + key + '"]');
    return el;
  }

  /* the cart page's form; the drawer's form comes first in the page, so a bare form[action*="/cart"] picked the drawer */
  function mainCart() {
    return document.getElementById('main-cart-items') || document.querySelector('.main-cart') ||
      document.querySelector('[id$="__main-cart"] form[action*="/cart"]');
  }

  function enhance(cart) {
    css();
    var g = groups(cart);
    var roots = [document.getElementById('Cart-Drawer'), mainCart()].filter(Boolean);
    roots.forEach(function (root) {
      Array.prototype.forEach.call(root.querySelectorAll('.rjcc-head'), function (h) { h.remove(); });
      Object.keys(g).forEach(function (id) {
        var grp = g[id];
        var rank = function (r) { return r in ROLE_ORDER ? ROLE_ORDER[r] : 1; };
        grp.items.sort(function (a, b) { return rank(a.role) - rank(b.role); });
        var els = grp.items.map(function (x) { return { x: x, el: lineEl(root, x.item.key) }; }).filter(function (o) { return o.el; });
        if (!els.length) return;
        var first = els[0].el, parent = first.parentNode;
        /* keep the build's lines together, chain first */
        els.forEach(function (o, i) {
          if (i > 0 && o.el.parentNode === parent && els[i - 1].el.nextElementSibling !== o.el) parent.insertBefore(o.el, els[i - 1].el.nextSibling);
          o.el.classList.add('rjcc-locked', 'rjcc-line');
          if (o.x.role === 'charm' && o.x.item.quantity > 1 && !o.el.querySelector('.rjcc-qty')) {
            var info = o.el.querySelector('.product-cart-item-info--inner-second') || o.el;
            var q = document.createElement('span'); q.className = 'rjcc-qty'; q.textContent = '× ' + o.x.item.quantity; info.appendChild(q);
          }
        });
        var total = grp.items.reduce(function (a, x) { return a + x.item.final_line_price; }, 0);
        var charms = grp.items.filter(function (x) { return x.role === 'charm'; }).reduce(function (a, x) { return a + x.item.quantity; }, 0);
        var head = document.createElement('div');
        head.className = 'rjcc-head';
        var tag = String((grp.items[0].item.properties || {})['Charm Bar build'] || ('#' + id));
        var label = document.createElement('span');
        var strong = document.createElement('strong'); strong.textContent = 'Your Charm Bar build';
        label.appendChild(strong);
        label.appendChild(document.createTextNode(' ' + tag + ' · ' + charms + ' charm' + (charms === 1 ? '' : 's') + ' · ' + money(total, cart.currency)));
        var btn = document.createElement('button'); btn.type = 'button'; btn.setAttribute('data-rjcc-remove', id); btn.textContent = 'Remove this build';
        head.appendChild(label); head.appendChild(btn);
        if (warnings[id]) { var w = document.createElement('span'); w.className = 'rjcc-warn'; w.setAttribute('role', 'alert'); w.textContent = warnings[id]; head.appendChild(w); }
        parent.insertBefore(head, first);
      });
    });
  }

  var observers = [], lastSig = '';
  function pause() { observers.forEach(function (o) { o.obs.disconnect(); }); }
  function resume() { observers.forEach(function (o) { o.obs.observe(o.el, { childList: true, subtree: true }); }); }
  function hasLines() { return !!document.querySelector('#Cart-Drawer quantity-selector, #main-cart-items quantity-selector, .main-cart quantity-selector, [id$="__main-cart"] quantity-selector'); }
  function run() {
    if (busy) return;
    if (!hasLines()) return; /* empty cart: no request at all */
    busy = true;
    getCart().then(function (cart) {
      return repair(cart).then(function (changed) {
        if (changed) { busy = false; lastSig = ''; refreshUi(); return; }
        var sig = cart.items.map(function (i) { return i.key + ':' + i.quantity; }).join('|');
        var builds = Object.keys(groups(cart)).length;
        if (sig === lastSig && document.querySelectorAll('.rjcc-head').length >= builds) { busy = false; return; }
        lastSig = sig;
        pause();
        try { enhance(cart); } finally { resume(); }
        busy = false;
      });
    }).catch(function (e) { busy = false; console.warn('[rjcc]', e); });
  }
  function schedule() { clearTimeout(timer); timer = setTimeout(run, 200); }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-rjcc-remove]');
    if (!b) return;
    e.preventDefault();
    var id = b.getAttribute('data-rjcc-remove');
    b.disabled = true;
    b.textContent = 'Removing…';
    getCart().then(function (cart) {
      var upd = {};
      cart.items.forEach(function (it) { if ((it.properties || {})._build_id === id) upd[it.key] = 0; });
      return post('/cart/update.js', { updates: upd });
    }).then(function () {
      try { if (window.Shopify && Shopify.analytics) Shopify.analytics.publish('charm_build_removed', { build_id: id }); } catch (e2) { /* ignore */ }
      refreshUi();
    });
  });

  function observe() {
    [document.getElementById('Cart-Drawer'), mainCart()].forEach(function (el) {
      if (!el || el.__rjccObs) return;
      var obs = new MutationObserver(function (muts) {
        if (muts.some(function (m) { return Array.prototype.some.call(m.addedNodes, function (n) { return n.nodeType === 1 && !(n.classList && (n.classList.contains('rjcc-head') || n.classList.contains('rjcc-qty'))); }); })) { lastSig = ''; schedule(); }
      });
      el.__rjccObs = obs;
      observers.push({ el: el, obs: obs });
      obs.observe(el, { childList: true, subtree: true });
    });
  }

  function boot() { observe(); schedule(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('cart:refresh', function () { lastSig = ''; setTimeout(schedule, 400); });
})();
